import { Api } from 'utils';

class Preparation {
  static get = async (params = {}) => Api.createResponse('app/preparation/', params);
  static create = async (params = {}) => Api.createResponse('app/preparation/create', params);
  // Casos 2 y 3: membresía activa (con o sin usos) — sin pago de plataforma.
  static createNoPayment = async (params = {}) =>
    Api.createResponse('app/preparation/create-no-payment', params);
  static getLawyers = async (params = {}) => Api.createResponse('app/preparation/lawyers', params);
  static getAreas = async (params = {}) => Api.createResponse('app/preparation/areas', params);
  static getLawyerDetail = async (params = {}) =>
    Api.createResponse('app/preparation/lawyer-detail', params);
  static getDocumentsByArea = async (params = {}) =>
    Api.createResponse('app/preparation/area-documents', params);
  static viewComments = async (params = {}) =>
    Api.createResponse('app/preparation/view-comments', params);
  static sendComments = async (params = {}) =>
    Api.createResponse('app/preparation/send-comments', params);
  static changeStatus = async (params = {}) =>
    Api.createResponse('app/preparation/change-status', params);
  static sendLawyerNotification = async (params = {}) =>
    Api.createResponse('app/preparation/send-lawyer-notification', params);
  static getSearchPreparation = async (params = {}) =>
    Api.createResponse('app/preparation/search-preparation', params);
  static changeSearchPreparationStatus = async (params = {}) =>
    Api.createResponse('app/preparation/change-search-preparation-status', params);
  static acceptPreparation = async (params = {}) =>
    Api.createResponse('app/preparation/accept-preparation', params);
  static rating = async (params = {}) => Api.createResponse('app/preparation/rating', params);

  static admin = {
    get: async (params = {}) => Api.createResponse('admin/preparation/', params),
  };
}

export default Preparation;
